import React from 'react';
import { Grid } from '@mui/material';
import MetricDetailGridItem from './MetricDetailGridItem';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { AuditInfoTooltip } from './AuditInfoTooltip';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const MetricDetail = React.memo((props) => {
    const { metric, open, setOpen, setEdit, user } = props;
  
    const handleClose = () => {
      setOpen(false);
    }
  
    const handleEdit = () => {
      setEdit(true);
    }

    const metricSourceFields = (metric) => {
      return {
        "createdDate": metric.sourceFieldsCreatedDate,
        "lastUpdatedDate": metric.sourceFieldsLastUpdatedDate,
        "lastUpdatedBy": metric.sourceFieldsLastUpdatedBy
      }
    }
      
      return (
        <>
          <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
          maxWidth="lg"
        >
          <DialogTitle><AuditInfoTooltip row={metric}/>{" Metric Detail"}</DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              <MetricDetailGridItem label="Name:" value={metric.name}
                tooltip={
                    <span>
                      This is an internal name for the metric, it should be unique and descriptive. This is not to be be used for any reporting purposes.
                    </span>
                }
               />
              <MetricDetailGridItem label="Display Name:" value={metric.displayName}
                tooltip={
                  <>
                    <p>
                      Often used as the metric name on reports, so <b>must be in line with other reporting requirements such as the pre-contractural document for SFDR KSIs</b>
                    </p>
                    <p>
                      At the fund/entity level, some ESG metrics (e.g., <b>WACI</b> - Weighted Average Carbon Intensity) may have different names or calculations at the position & company level (e.g., <b>Scope 1 Emissions</b>), as fund-level data is typically rolled up and weighted from the underlying positions.
                    </p>
                  </>
                }
               />
              <MetricDetailGridItem label="Position & Company Level Name:" value={metric.positionAndCompanyLevelName}
                tooltip={
                     <span>
                      At the position level, some ESG metrics (e.g., <b>Scope 1 Emissions</b>) may have different names or calculations at the rolled up fund/entity level (e.g., <b>WACI</b> - Weighted Average Carbon Intensity), as fund-level data is typically rolled up and weighted from the underlying positions.
                    </span>
                }
               />
              <MetricDetailGridItem label="Metric Description:" value={metric.metricDescription}
                tooltip="A useful description and any relevant information to this metric. This is not presently required."
              />
              <br/>
              <br/>
              <Grid item sm={3}>
                <AuditInfoTooltip row={metricSourceFields(metric)}/>  Source Fields
              </Grid>
              <Grid item sm={9}></Grid>
              <MetricDetailGridItem label="Source Product Suite:" value={metric.sourceProductSuite} />
              <MetricDetailGridItem label="Metric Value Source Field:" value={metric.sourceDataProductMetricTypeCode} />
              <MetricDetailGridItem label="Metric Value Type:" value={metric.metricValueType}
                tooltip={
                    <>
                      <span>M&G have two available values when calculating fund/entity metric values from the underlying holdings metrics:</span>
                      <ol>
                        <li><strong>Absolute</strong> - based on the assets in scope "carveout" for numerator and denominator. Includes all in scope holdings even when metric value not available i.e. impacts denominator but no numerator.</li>
                        <li><strong>Normalised</strong> - based only on the assets in scope "carveout" that have metrics value. i.e. reweighted/reduction in the denominator. Equivalent to all positions with no metric assumed to have the average value.</li>
                      </ol>
                    </>
                }
               />
              <MetricDetailGridItem label="Value Unit Type:" value={metric.valueUnitType} />
              <MetricDetailGridItem label="Currency:" value={metric.metricCurrency} tooltip= "Currency is not applicable for all metrics, so it may be blank." />
              <MetricDetailGridItem label="Metric Carve-out:" value={metric.metricCarveout} tooltip="Metric-carveout defines the scope of the metrics, i.e. which positions are included in the metric calculation." />
            </Grid>
          </DialogContent>
          <DialogActions>
            {
              user.hasMaintainerRole === true && setEdit !== undefined
            ?
              <Button onClick={handleEdit}>Edit</Button>
            :
              <></>
            }
            <Button onClick={handleClose}>Close</Button>          
          </DialogActions>
        </Dialog>
        </>
      );
  });

export default MetricDetail;